import React from 'react';

const CREWS = [
  // Individual crew members (main installers)
  { id: 'adam', name: 'Adam', color: '#3b82f6', type: 'individual' },
  { id: 'kevin', name: 'Kevin', color: '#8b5cf6', type: 'individual' },
  { id: 'steve', name: 'Steve', color: '#10b981', type: 'individual' },
  
  // Teams of 2
  { id: 'adam-kevin', name: 'Adam + Kevin', color: '#3b82f6', type: 'team' },
  { id: 'adam-steve', name: 'Adam + Steve', color: '#3b82f6', type: 'team' },
  { id: 'kevin-steve', name: 'Kevin + Steve', color: '#8b5cf6', type: 'team' },
  
  // Team of 3
  { id: 'adam-kevin-steve', name: 'Adam + Kevin + Steve', color: '#8B4513', type: 'team' },
  
  // Small job crew (deliveries, single windows)
  { id: 'mike', name: 'Mike (Small Jobs)', color: '#f59e0b', type: 'small' },
  { id: 'justin', name: 'Justin (Small Jobs)', color: '#f59e0b', type: 'small' }
];

export default function CrewSelector({ value, onChange, error }) {
  // Group crews by type
  const individuals = CREWS.filter(c => c.type === 'individual');
  const teams = CREWS.filter(c => c.type === 'team');
  const smallJobs = CREWS.filter(c => c.type === 'small');

  return (
    <div>
      <label style={{
        display: 'block',
        fontSize: '13px',
        fontWeight: '600',
        color: '#2b2b2b',
        marginBottom: '6px'
      }}>
        Assign to Crew
      </label>
      
      <select
        value={value || ''}
        onChange={(e) => onChange(e.target.value)}
        style={{
          width: '100%',
          padding: '10px 12px',
          border: error ? '1px solid #dc2626' : '1px solid #ddd',
          borderRadius: '8px',
          fontSize: '14px',
          outline: 'none',
          background: 'white'
        }}
        onFocus={(e) => {
          if (!error) e.target.style.borderColor = '#8B4513';
        }}
        onBlur={(e) => {
          if (!error) e.target.style.borderColor = '#ddd';
        }}
      >
        <option value="">Select a crew...</option>
        
        {/* Individual Installers */}
        <optgroup label="── Individual Installers ──">
          {individuals.map(crew => (
            <option key={crew.id} value={crew.id}>
              👷 {crew.name}
            </option>
          ))}
        </optgroup>
        
        {/* Teams */}
        <optgroup label="── Installation Teams ──">
          {teams.map(crew => (
            <option key={crew.id} value={crew.id}>
              👷👷 {crew.name}
            </option>
          ))}
        </optgroup>
        
        {/* Small Jobs */}
        <optgroup label="── Small Jobs / Delivery ──">
          {smallJobs.map(crew => (
            <option key={crew.id} value={crew.id}>
              🚚 {crew.name}
            </option>
          ))}
        </optgroup>
      </select>
      
      {error && (
        <div style={{
          fontSize: '12px',
          color: '#dc2626',
          marginTop: '4px'
        }}>
          {error}
        </div>
      )}
      
      <div style={{
        fontSize: '11px',
        color: '#999',
        marginTop: '4px'
      }}>
        Optional - can be assigned later
      </div>
    </div>
  );
}

export { CREWS };